import React from "react";

const BluePrint = ({ draft }) => {
  if (!draft || Object.keys(draft).length === 0) return null;

  const fields = [
    { key: "timeCommitment", label: "⏳ Time Commitment" },
    { key: "vision", label: "🎯 Vision" },
    { key: "proofOfLife", label: "✨ Proof of Life" },
    { key: "firstSignal", label: "📢 First Signal" },
    { key: "milestone", label: "🏆 Milestone" },
  ];

  return (
    <div className="mt-4 rounded-xl border border-gray-200 bg-gradient-to-br from-slate-50 via-white to-slate-100 shadow-md">
      <div className="px-4 py-3 border-b border-gray-100">
        <h2 className="text-sm font-semibold tracking-wide uppercase text-gray-600">
          Blueprint
        </h2>
        <p className="text-xs text-gray-400 mt-0.5">
          Your inputs for Codi to craft checkpoints
        </p>
      </div>

      <div className="p-4 space-y-3">
        {fields.map(({ key, label }) => (
          <div
            key={key}
            className="flex items-start justify-between gap-3 rounded-lg bg-white px-3 py-2 border border-gray-100 shadow-sm"
          >
            <span className="text-xs font-medium text-gray-500">{label}</span>
            <span className="text-sm text-gray-800 text-right flex-1">
              {draft[key] || <span className="italic text-gray-400">Not answered yet</span>}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BluePrint;
